// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__PzM44","particles":"MainLayout_particles__s7Sh-","content":"MainLayout_content__p8nHO"};